"use client";

import { useRef } from "react";

import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Button } from "@/src/components/ui/Button";
import { Heading, Text } from "@/src/components/ui/Typography";
import { StickyColumnUntilLevel } from "@/src/components/molecules/StickyColumnUntilLevel";
import { Accordion } from "@/src/components/molecules/Accordion";
import { paths } from "@/src/routes/paths";

interface CapabilitiesProps {
  title: string;
  intro?: string;
  items: Array<{ title: string; body: string }>;
}

export function Capabilities({ title, intro, items }: CapabilitiesProps) {
  const boundsRef = useRef<HTMLDivElement>(null);

  if (items.length === 0) return null;

  return (
    <Section className="bg-neutral-100">
      <Container>
        <div className="grid gap-12 md:grid-cols-2 md:gap-24">
          <StickyColumnUntilLevel boundsRef={boundsRef} className="h-fit self-start">
            <Heading as="h2" size="displayLG" className="max-w-125">
              {title}
            </Heading>

            {intro && (
              <Text size="bodyLG" className="mt-6 max-w-125 text-neutral-600">
                {intro}
              </Text>
            )}

            <div className="mt-10">
              <Button href={paths.contactUs} className="w-full md:w-auto">Start a Conversation</Button>
            </div>
          </StickyColumnUntilLevel>

          <div ref={boundsRef}>
            <Accordion
              items={items.map((item) => ({ title: item.title, content: item.body }))}
              defaultOpenIndex={0}
            />
          </div>
        </div>
      </Container>
    </Section>
  );
}
